import { HTTP_STATUSES } from "@miplatform/constants";
import { IApiRequest } from "@miplatform/types";
import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/homes`;

export const homes = {
  getAll: async ({ filters, sort, params, signal, top, skip }: IApiRequest) => {
    const options = await apiOptions({
      url: API_HOMES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getById: async ({ id }: { id: string }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  getUpdateOptions: async ({ id, data }: IApiRequest) =>
    apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    }),
  update: async ({ id, data, toastMessageConfig }: IApiRequest) => {
    const options = await homes.getUpdateOptions({ id, data });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
    const response = await apiRequest(options, toastMessageConfig);
    if (response.status === HTTP_STATUSES.OK) {
      return response.data;
    }
    return null;
  },
  create: async ({ data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: API_HOMES,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getContactTypes: async () => {
    const options = await apiOptions({
      url: `${HOME_SERVICE}/contact-types`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  createContact: async ({
    homeId,
    data,
    toastMessageConfig,
  }: ICreateContactPayload) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${homeId}/contacts`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  updateContact: async ({
    homeId,
    contactId,
    data,
    toastMessageConfig,
  }: IUpdateContactPayload) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${homeId}/contacts/${contactId}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getHomeLayout: async () => {
    const options = await apiOptions({
      url: `${HOME_SERVICE}/homelayout`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    const response = await apiRequest(options);
    if (response.status === HTTP_STATUSES.OK) {
      return response.data;
    }
    return null;
  },
};

interface ICreateContactPayload extends IApiRequest {
  homeId: string;
  data: {
    contactTypeId: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
  };
}

interface IUpdateContactPayload extends ICreateContactPayload {
  contactId: string;
}
